const context = require.context("./stages", true, /\.(js|jsx|ts|tsx)$/);

function basenameNoExt(path) {
  // "./Four_Players_Stage1_Player1.js" -> "Four_Players_Stage1_Player1"
  const file = path.split("/").pop() || "";
  return file.replace(/\.(js|jsx|ts|tsx)$/, "");
}

const components = {};

// 1) Enregistre chaque module sous sa clé = nom de fichier
context.keys().forEach((path) => {
  const mod = context(path);
  const C = mod?.default ?? mod?.[Object.keys(mod || {})[0]];
  if (!C) return;

  const key = basenameNoExt(path);
  components[key] = C;
});

// 2) (Optionnel) Alias si tes fichiers ne matchent pas le backend
// Exemple : fichier "4Players_Stage1_Player1" mais backend "Four_Players_Stage1_Player1"
const ALIASES = {
  // 4 players
  "Four_Players_Stage1_Player1": "4Players_Stage1_Player1",
  "Four_Players_Stage1_Player2": "4Players_Stage1_Player2",
  "Four_Players_Stage1_Player3": "4Players_Stage1_Player3",
  "Four_Players_Stage1_Player4": "4Players_Stage1_Player4",
  "Four_Players_Stage2_Player1": "4Players_Stage2_Player1",
  "Four_Players_Stage2_Player2": "4Players_Stage2_Player2",
  "Four_Players_Stage2_Player3": "4Players_Stage2_Player3",
  "Four_Players_Stage2_Player4": "4Players_Stage2_Player4",
  "Four_Players_Stage3_Player1": "4Players_Stage3_Player1",
  "Four_Players_Stage3_Player2": "4Players_Stage3_Player2",
  "Four_Players_Stage3_Player3": "4Players_Stage3_Player3",
  "Four_Players_Stage3_Player4": "4Players_Stage3_Player4",
  // 5 players
  "Five_Players_Stage1_Player1": "5Players_Stage1_Player1",
  "Five_Players_Stage1_Player2": "5Players_Stage1_Player2",
  "Five_Players_Stage1_Player3": "5Players_Stage1_Player3",
  "Five_Players_Stage1_Player4": "5Players_Stage1_Player4",
  "Five_Players_Stage1_Player5": "5Players_Stage1_Player5",
  "Five_Players_Stage2_Player1": "5Players_Stage2_Player1",
  "Five_Players_Stage2_Player2": "5Players_Stage2_Player2",
  "Five_Players_Stage2_Player3": "5Players_Stage2_Player3",
  "Five_Players_Stage2_Player4": "5Players_Stage2_Player4",
  "Five_Players_Stage2_Player5": "5Players_Stage2_Player5",
  "Five_Players_Stage3_Player1": "5Players_Stage3_Player1",
  "Five_Players_Stage3_Player2": "5Players_Stage3_Player2",
  "Five_Players_Stage3_Player3": "5Players_Stage3_Player3",
  "Five_Players_Stage3_Player4": "5Players_Stage3_Player4",
  "Five_Players_Stage3_Player5": "5Players_Stage3_Player5",
  // 6 players
  "Six_Players_Stage1_Player1": "6Players_Stage1_Player1",
  "Six_Players_Stage1_Player2": "6Players_Stage1_Player2",
  "Six_Players_Stage1_Player3": "6Players_Stage1_Player3",
  "Six_Players_Stage1_Player4": "6Players_Stage1_Player4",
  "Six_Players_Stage1_Player5": "6Players_Stage1_Player5",
  "Six_Players_Stage1_Player6": "6Players_Stage1_Player6",
  "Six_Players_Stage2_Player1": "6Players_Stage2_Player1",
  "Six_Players_Stage2_Player2": "6Players_Stage2_Player2",
  "Six_Players_Stage2_Player3": "6Players_Stage2_Player3",
  "Six_Players_Stage2_Player4": "6Players_Stage2_Player4",
  "Six_Players_Stage2_Player5": "6Players_Stage2_Player5",
  "Six_Players_Stage2_Player6": "6Players_Stage2_Player6",
  "Six_Players_Stage3_Player1": "6Players_Stage3_Player1",
  "Six_Players_Stage3_Player2": "6Players_Stage3_Player2",
  "Six_Players_Stage3_Player3": "6Players_Stage3_Player3",
  "Six_Players_Stage3_Player4": "6Players_Stage3_Player4",
  "Six_Players_Stage3_Player5": "6Players_Stage3_Player5",
  "Six_Players_Stage3_Player6": "6Players_Stage3_Player6",

};

export function getOrigamiStageComponent(componentName) {
  if (!componentName) return null;

  // direct
  if (components[componentName]) return components[componentName];

  // alias
  const alias = ALIASES[componentName];
  if (alias && components[alias]) return components[alias];

  return null;
}

export function listOrigamiStageComponents() {
  return Object.keys(components);
}
